import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import SubmitButton from '../Buttons/SubmitButton';
import SimpleInput from '../Input/SimpleInput';
import ForgetPassword from '../ForgetPassword/ForgetPassword';
import { Box, Typography, Link, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login: loginUser } = useAuth();

  const from = location.state?.from?.pathname || '/dashboard';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await loginUser(formData);

      toast.success('Login successful!');

      requestAnimationFrame(() => {
        navigate(from || '/dashboard', { replace: true });
      });
    } catch (error) {
      toast.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: 10,
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      }}
    >
      {!showForgot ? (
        <Box
          sx={{
            bgcolor: 'white',
            p: 4,
            borderRadius: 4,
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Box
            component="img"
            src="/images/revivebussiness-loogo.png"
            alt="Company Logo"
            sx={{ width: 140 }}
          />

          <Typography variant="h5" fontWeight={700}>
            Welcome Back
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <SimpleInput
              type="email"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Email"
              required
            />

            <SimpleInput
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              required
            />

            <SubmitButton disabled={loading}>
              {loading ? (
                <>
                  <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
                  Signing In...
                </>
              ) : (
                'SIGN IN'
              )}
            </SubmitButton>
          </Box>

          <Link
            component="button"
            onClick={() => setShowForgot(true)}
            sx={{ textDecoration: 'underline' }}
          >
            Forgot password?
          </Link>

          <Box sx={{ mt: 1.5, textAlign: 'center' }}>
            <Typography
              variant="body2"
              sx={{
                color: '#6B7280',
                fontSize: 13,
              }}
            >
              Having trouble logging in?{' '}
              <Box
                component="span"
                sx={{
                  color: '#154A8A',
                  fontWeight: 500,
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Contact Support
              </Box>
            </Typography>
          </Box>
        </Box>
      ) : (
        <ForgetPassword onBack={() => setShowForgot(false)} />
      )}
    </Box>
  );
};

export default Login;
